import { render, staticRenderFns } from "./SideNavigation.vue?vue&type=template&id=6165a809&scoped=true"
import script from "./SideNavigation.vue?vue&type=script&lang=js"
export * from "./SideNavigation.vue?vue&type=script&lang=js"
import style0 from "./SideNavigation.vue?vue&type=style&index=0&id=6165a809&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6165a809",
  null
  
)

export default component.exports